import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/total_water_consumption');
  return response.data;
}

export default {
  index,
};
